<template>
  <div class="activity-chinese">
    <web-header language="cn" ref="webHeaderRef"></web-header>
    <div class="activity-chinese-wrap" v-loading="loading">
      <div class="activity-chinese-wrap-title">
        <template v-if="info.activity_class && info.activity_class.class_name">
          【{{ info.activity_class.class_name }}】{{ info.activity_name }}
        </template>
        <template v-else>
          {{ info.activity_nam }}
        </template>
      </div>
      <div class="activity-chinese-wrap-enroll">
        <template v-if="info.stop_reservation">
          <a :href="'/report/chinese/'+info.playback_file_id" target="_blank" class="activity-chinese-wrap-enroll-btn" v-if="info.playback_status == '1' && info.playback_file_id">查看回放</a>
          <template v-else>
            <el-alert :title="info.is_live ? '报名成功，请按时上线收看' : '报名成功，请留意查收手机提示短信'" type="success" effect="dark" :closable="false" v-if="info.has_reservation && !info.is_examine && info.activity_reservations && info.activity_reservations.id"></el-alert>
            <el-alert title="等待审核" type="warning" effect="dark" :closable="false" v-else-if="info.activity_reservations && info.activity_reservations.status==0"></el-alert>
            <el-alert title="报名成功，请留意查收手机提示短信" type="success" effect="dark" :closable="false" v-else-if="info.activity_reservations && info.activity_reservations.status==1"></el-alert>
            <template v-else-if="info.activity_reservations && info.activity_reservations.status==2">
              <el-alert :title="'未通过审核（原因）: '+info.activity_reservations.reject_reason" type="warning" effect="dark"></el-alert>
              <div class="activity-chinese-wrap-enroll-btn" @click="signUpActivity">再次报名</div>
            </template>
            <el-alert title="报名已结束" type="error" effect="dark" :closable="false" v-else></el-alert>
          </template>
        </template>
        <template v-else>
          <a :href="'/report/chinese/'+info.playback_file_id" target="_blank" class="activity-chinese-wrap-enroll-btn" v-if="info.playback_status == '1' && info.playback_file_id">查看回放</a>
          <template v-else>
            <el-alert :title="info.is_live ? '报名成功，请按时上线收看' : '报名成功，请留意查收手机提示短信'" type="success" effect="dark" :closable="false" v-if="info.has_reservation && !info.is_examine && info.activity_reservations && info.activity_reservations.id"></el-alert>
            <template v-if="info.is_examine">
              <el-alert title="等待审核" type="warning" effect="dark" :closable="false" v-if="info.activity_reservations && info.activity_reservations.status==0"></el-alert>
              <el-alert title="报名成功，请留意查收手机提示短信" type="success" effect="dark" :closable="false" v-else-if="info.activity_reservations && info.activity_reservations.status==1"></el-alert>
              <el-alert :title="'未通过审核（原因）: '+info.activity_reservations.reject_reason" type="warning" effect="dark" v-else-if="info.activity_reservations && info.activity_reservations.status==2"></el-alert>
            </template>
            <div class="activity-chinese-wrap-enroll-btn" @click="signUpActivity" v-if="(!info.has_reservation && (!info.activity_reservations || !info.activity_reservations.id)) || (info.is_examine && info.activity_reservations.status==2)">
              {{ info.activity_reservations && info.activity_reservations.status==2 ? '再次报名' : '立即报名' }}
            </div>
          </template>
        </template>
      </div>
      <div class="activity-chinese-wrap-content" v-html="info.activity_desc"></div>
    </div>
    <!-- 登录 -->
    <login-chinese ref="loginChineseRef" @success="loginSuccess"></login-chinese>
    <!-- 报名表单 -->
    <sign-up-chinese ref="signUpChineseRef" @callback="getDetailById"></sign-up-chinese>
    <web-footer language="cn"></web-footer>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import WebHeader from "@/components/webHeader";
import WebFooter from "@/components/webFooter";
import SignUpChinese from "./signUpChinese.vue";
import LoginChinese from "@/components/loginChinese/index.vue";
import { singleActivity, userInfo } from '@/api';
export default {
  name: 'ActivityChinese',
  components: {
    WebHeader,
    WebFooter,
    SignUpChinese,
    LoginChinese
  },
  props: {
    id: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      memberInfo: {},
      info: {}
    }
  },
  created() {
    this.getDetailById();
  },
  methods: {
    // 通过ID获取数据详情
    async getDetailById() {
      this.loading = true;
      if (this.id && Number(this.id) > 0) {
        let res = await singleActivity(this.id);
        if (res && res.code == 200) {
          this.info = res.data;
        }
      } else {
        this.$router.go(-1);
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    // 获取用户信息
    async getUserInfo() {
      let token = localStorage.getItem("cf40-token");
      if (token) {
        let res = await userInfo();
        if (res && res.code == 200) {
          this.memberInfo = res.data.user_info;
        }
      } else {
        this.$refs.loginChineseRef.open();
      }
    },
    // 报名
    async signUpActivity() {
      await this.getUserInfo();
      if (this.memberInfo && this.memberInfo.id) {
        this.$refs.signUpChineseRef.openSignUp(this.info);
      }
    },
    // 报名成功
    loginSuccess() {
      this.$refs.signUpChineseRef.openSignUp(this.info);
    },
  }
}
</script>
<style scoped lang="scss">
.activity-chinese {
  &-wrap {
    font-family: "HarmonyOS_Sans_Regular";
    width: 50%;
    margin: 50px auto 80px auto;
    &-title {
      font-size: 44px;
      font-family: HarmonyOS_Bold;
      color: #1E1E1E;
      padding-bottom: 50px;
      border-bottom: 1px solid #CCCCCC;
    }
    &-enroll {
      margin: 50px 0 50px 0;
      &-btn {
        max-width: 208px;
        margin-top: 30px;
        cursor: pointer;
        text-align: center;
        color: #ffffff;
        padding: 10px 0;
        border-radius: 6px;
        background-color: #ED6F33;
        display: block;
        text-decoration: none;
        &:hover,&:active {
          background-color: #f68a56;
        }
      }
      &-error {
        max-width: 208px;
        cursor: not-allowed;
        text-align: center;
        color: #ffffff;
        padding: 10px 0;
        border-radius: 6px;
        background-color: #ED6F33;
      }
      ::v-deep {
        .el-alert {
          padding: 12px 16px;
          &__title {
            font-size: 14px;
          }
          &--error.is-dark {
            background-color: #ED6F33;
          }
        }
      }
    }
  }
}
/* 针对平板 */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .activity-chinese {
    &-wrap {
      width: calc(100% - 60px);
      &-title {
        font-size: 32px;
        padding-bottom: 30px;
      }
      &-enroll {
        margin: 50px 0 30px 0;
        &-btn {
          max-width: 50%;
        }
      }
    }
  }
}
/* 针对手机 */
@media screen and (max-width: 767px) {
  .activity-chinese {
    &-wrap {
      width: calc(100% - 60px);
      &-title {
        font-size: 26px;
        padding-bottom: 30px;
      }
      &-enroll {
        margin: 30px 0 30px 0;
        &-btn {
          max-width: 60%;
        }
      }
    }
  }
}
</style>
